import React, {Component} from 'react';
import LandingView from "../views/LandingView";
import {Loading, withCourseStatisticsApi} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import {Link} from "react-router-dom";
import {route} from "../../../routes";
import { withTranslation } from 'react-i18next';
import i18n from "../../../i18n";
class LandingController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    // Set the initial state of the form filter values.
    this.state = {
      summary: {},
      summaryLoaded: false,
      review: [],
      reviewLoaded: false,
      reviewItems: []
    }
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.props.courseStatisticsApiGetSummary((response) => {

      this.setState({
        summary: {
          venues: response.data['Venues'],
          courses: response.data['Courses'],
          contacts: response.data['Contacts'],
        },
        summaryLoaded: true
      });
    }, (error) => {
      this.setState({
        summary: {
          venues: [],
          courses: [],
          contacts: [],
        },
        summaryLoaded: true
      }, () => {

      });
    });

    this.props.courseStatisticsApiGetReview(i18n.language, (response) => {
      let reviewItems = [];
      // @todo constant for 200?
      if (response.status === 200) {
        response.data.forEach((element, i) => {

          let body = element.providerList.map((providerListElement, providerListindex) => {


            let groups = providerListElement.courseGroups.map((courseGroupsElement, courseGroupsindex) => {

              return <li key={courseGroupsindex}><Link
                to={route('courseGroupsManage') + "/" + route('courseGroupsEdit' ,{"courseGroup" : courseGroupsElement.id})}>{courseGroupsElement.courseGroupName}</Link>
              </li>
            })

            return <div key={providerListindex} className={'gel-xs-mt-20'}><p ><strong> {providerListElement.mainProvider.cw_courseprovidername} </strong></p><ul className={'style--list-plain'}>{groups}</ul>
            </div>;

          }, this);

          reviewItems.push({
            id: element.id,
            title: this.props.courses.assets.courseGroups.courseGroupTypeLookup[element.id] + " (" + element.count + ")",
            body: body
          })
        }, this)


        this.setState({
          reviewItems: reviewItems,
          reviewLoaded: true
        }, () => {

        });

      } else {
        this.setState({
          reviewItems: [],
          reviewLoaded: true
        }, () => {

        });
      }


    }, (error) => {
      this.setState({
        reviewItems: [],
        reviewLoaded: true
      }, () => {

      });

    });

  }

  render() {
    // If the user is not logged in.
    // if (!this.state.summaryLoaded || !this.state.reviewLoaded ) {
    //
    //   return <Loading text={this.props.t('local:view.landing.messages.loadingSummary')}/>
    // }

    return <LandingView {...this.state} />;
  }
}

export default withCourseStatisticsApi(process.env)(withAssets(withTranslation('local')(LandingController)));
